<section class="operations-shell">
    <app-operations-back-link
            routerLink="/vision-configuration/provider-management"
            label="← Back to Providers"
    ></app-operations-back-link>

    <header class="operations-shell__header">
        <div>
            <h1 class="operations-shell__title">{{ providerLabel || formatProviderLabel(providerId,
                showImplementationDetails) }}</h1>
            <p class="operations-shell__subtitle">
                {{ showImplementationDetails ? 'Provider details' : 'Vision service details' }} for {{ providerSubtitle
                }}.
            </p>
        </div>
        <span *ngIf="!loading" [class]="statusClass()">{{ healthLabel }}</span>
    </header>

    <nav class="operations-shell__nav" aria-label="Provider detail tabs">
        <a *ngFor="let item of tabItems"
           class="operations-shell__nav-link"
           [routerLink]="tabPath(item.segment)"
           routerLinkActive="operations-shell__nav-link--active">
            {{ item.label }}
        </a>
    </nav>

    <router-outlet></router-outlet>
</section>
